import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';
import mixins from './mixins/mixins';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

if (document.sentryUrl) {
  Sentry.init({
    Vue,
    dsn: document.sentryUrl,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'headsup.eosphere.io', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    logErrors: true,
  });
}

mixins;

Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');

// Location of the source map for sentry
//# sourceMappingURL=app.js.map
